export const sort = (list, comparator = (item) => item) => {
  return list.sort((a, b) =>
    comparator(a).localeCompare(comparator(b), undefined, { numeric: true })
  );
};

export function formatToReadableTime(date) {
  return date.toLocaleString("en-US", {
    minute: "2-digit",
    hour: "2-digit",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
